// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.icon-base[data-v-134840c2] {\n   display: inline-block;\n   vertical-align: middle;\n   fill: currentColor;\n   width: 2rem;\n   height: 2rem;\n   stroke-width: 0;\n   stroke: currentColor;\n   overflow: hidden;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
